// src/pages/chat/welcome-content/welcome-content.styled.ts
import styled from "@emotion/styled";
import { tablet } from "../../../media";

export const WelcomeContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    ${tablet`
        max-width: 720px;
        margin: 0 auto;
    `}
`;

export const WelcomeTitle = styled.h1`
    font-family: "Custora", serif;
    font-weight: 400;
    font-style: normal;
    font-size: 24px;
    line-height: 140%;
    letter-spacing: 0px;
    text-align: center;
    color: #e9ecf5;
    white-space: nowrap;
    margin: 0; /* ✅ remove margin so spacing is controlled by TitleSlot */
`;

export const LogoWrapper = styled.div`
    position: relative;
    width: 250px;
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
    color: rgba(183, 189, 203, 0.80);
    font-size: 15px;
    font-family: Inter;
    font-weight: 500;
    letter-spacing: 1px;
    word-wrap: break-word;

    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;

    &:focus {
        outline: none;
    }
`;

export const OuterGlowCircle = styled.div`
    position: absolute;
    inset: 0;
    border-radius: 999px;
    background: #003fd7d9;
    opacity: 0.25;
    -webkit-backdrop-filter: blur(24px);
    backdrop-filter: blur(24px);
`;

export const InnerCircle = styled.div`
    position: absolute;
    width: 104.6216812133789px;
    height: 104.6216812133789px;
    border-radius: 999px;
    background: #1b1b1e;
    border-width: 1px 1px 0px 0px;
    border-style: solid;
    border-color: var(--Brand-Accent, #5e84ed);
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
`;

export const LogoImage = styled.img`
    width: 42.949134826660156px;
    height: 42.94981002807617px;
    display: block;
`;

export const MicBadge = styled.div`
    position: absolute;
    width: 24px;
    height: 24px;
    border-radius: 999px;
    background: #5e84ed;
    border: 1px solid #98b3ff;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 0;
    right: 20px;
    box-sizing: border-box;
`;

export const MicIcon = styled.img`
    width: 12px;
    height: 16px;
    display: block;
    object-fit: contain;
    margin: auto;
    filter: brightness(0) invert(1);
`;

export const TitleSlot = styled.div`
    position: relative;
    width: 100%;
    height: 80px; /* ~34 + 44, rounded to 8pt grid */
    display: flex;
    align-items: flex-end;
    justify-content: center;
    pointer-events: none;
`;

export const StatusText = styled.span`
    color: rgba(183, 189, 203, 0.80);
    font-size: 15px;
    font-family: Inter, sans-serif;
    font-weight: 500;
    letter-spacing: 1px;
    text-align: center;
    white-space: nowrap;
`;
